type ApiErrorItem = {
  message?: string;
};

type ApiErrorPayload = {
  errors?: unknown;
  data?: unknown;
  detail?: string;
};

function parsePayload(payload: unknown): unknown {
  if (typeof payload !== "string") {
    return payload;
  }

  try {
    return JSON.parse(payload) as unknown;
  } catch {
    return payload;
  }
}

function extractFromErrorsField(errors: unknown): string | undefined {
  if (Array.isArray(errors)) {
    const [first] = errors;
    if (typeof first === "string" && first.trim()) {
      return first;
    }
    if (first && typeof first === "object") {
      const { message } = first as ApiErrorItem;
      if (typeof message === "string" && message.trim()) {
        return message;
      }
    }
  }

  if (errors && typeof errors === "object" && !Array.isArray(errors)) {
    const values = Object.values(errors as Record<string, unknown>);
    for (let index = 0; index < values.length; index += 1) {
      const value = values[index];
      if (typeof value === "string" && value.trim()) {
        return value;
      }
      if (Array.isArray(value)) {
        const nested = value.find(
          (item) => typeof item === "string" && item.trim(),
        );
        if (typeof nested === "string") {
          return nested;
        }
      }
    }
  }

  return undefined;
}

export function getFirstApiErrorMessage(payload: unknown): string | undefined {
  const parsed = parsePayload(payload);

  if (!parsed || typeof parsed !== "object") {
    return undefined;
  }

  const record = parsed as ApiErrorPayload;

  const fromErrors = extractFromErrorsField(record.errors);
  if (fromErrors) {
    return fromErrors;
  }

  if (typeof record.detail === "string" && record.detail.trim()) {
    return record.detail;
  }

  if (record.data && typeof record.data === "object") {
    return getFirstApiErrorMessage(record.data);
  }

  return undefined;
}
